import { SET_STRIPE_API_KEY } from "./stripe-types";

export const setUseLiveStripeValue = (value) => async (dispatch) =>{

    dispatch({
        type: SET_STRIPE_API_KEY,
        payload: value
    });
  }